export default {
    login: {
        email: "email",
        password: "password",
        submit: "Login",
        submit_new_pass: "Save",
        label_pass: "Forgot your password?",
        text_change_pass: "Hi, this is your first access to our platform. First, you need to create a password to be allowed to login.",
        text_forget_pass: "Confirm your registered email to receive a link to reset your password.",
        text_change_pass_code: "Hi, to reset your password, enter the code sent by email so you can create a new password.",
        old_pass: "Old Password",
        new_pass: "New Password",
        code: "Code",
        new_pass_confirm: "New password confirm",
        alerts: {
            pass_diferent: "Please make sure the passwords match.",
            new_pass: "Password configured! Please login again using your new password.",
            incorrect: "Incorrect login or password.",
            mandatory: "Login and password Required.",
            success_change: "Your password has been successfully accepted! You can log in.",
            success_email_sent_title: "Email successfully sent! ",
            success_email_sent_text: "Check your email inbox. You have received a code and a link to reset your password.",
        }
    },
    sideBar: {
        intelligentJourney: {
            title: "Intelligent Journey",
            links: ["Dashboards", "Planning Review","Reports","Generate report","Financial Statement", "Cockpit"],
        },
        jobs: {
            title: "Executed jobs",
            links: ["Executed jobs"],
        },
        dataset: {
            title: "Upload",
            links: [ "Upload", "SFTP", "API"],
        },
        repositorio: {
            title: "Repository",
            links: ["Format", "Master Data"],
        },
    },
    pedidos: {
        tabs: ["Dashboard", "Table"],
        status: {
            cards: [
                {
                    title: "Lead Time / Maximum",
                    subtitle: "Days",
                    amount: 5,
                },
                {
                    title: "Lead Time / Minimum",
                    subtitle: "Days",
                    amount: 3.2,
                },
                {
                    title: "Lead Time / Average",
                    subtitle: "Days",
                    amount: 4.4,
                },
                {
                    title: "Average Prediction",
                    subtitle: "Days",
                    amount: 4,
                },
                {
                    title: "Conversion",
                    subtitle: "Revenue Vol. & Ordered Vol.",
                    amount: 1.408,
                },
            ],
            clientInput: {
                label: "Client",
                placeholder: "All clients",
            },
            PeriodInput: {
                label: "Period",
            },
            dataFlow: {
                label: "Dataflow",
            },
        },
    },
    captura: {
        manual: {
            tabs: ["Upload"],
            title: "Upload your files.",
            subtitle:
                "",
            uploadLabel: "Drag and drop files here, or click here."
        },
        processando: {
            tabs: ["Progress"],
            title: "Envie aqui seus arquivos.",
            subtitle:
                "",
            table_title: "Files",
        },
        processando_table_header: {
            table: ["Status", "Agent", "Last Update", "User", "File", "Upload Date", "Message"]
        }
    },
    repositorio: {
        formato: {
            tabs: ["Schema"],
            title: "TEXTO BR AQUI",
            subtitle:
                "COMO FUNCIONA EM BR AQUI.",
            table_title: "Schema",
            uploadLabel: "Drag and drop files here, or use the button to the right."
        },
        formato_table_header: {
            table: [
                "File", "User", "Upload Date", "Download file"
            ]
        }
    }

}
